import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { GoogleMap, Marker, InfoWindow, Polyline, LoadScript, LoadScriptNext, StreetViewPanorama, DirectionsService, DirectionsRenderer } from "@react-google-maps/api";
import "./tour.css";
import AudioPlayer from 'react-h5-audio-player';
import 'react-h5-audio-player/lib/styles.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { Translator } from './translator';
import { claimMedia } from "./mediaGuard";
import AdBanner from "./AdBanner";
import AdSlot from "./AdSlot";

const GOOGLE_MAPS_API_KEY = "AIzaSyCOa-Vx3796Zb7OSqUu9qknCyKPwDY6H28";
const BASE = "https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com";


const Tour = () => {
  const { tourID } = useParams();

  const decodeHtmlEntities = (text) => { const textarea = document.createElement("textarea"); textarea.innerHTML = text; return textarea.value; };
  
  const parseBoldText = (text) => {
    return text.split(/(<strong>.*?<\/strong>)/g).map((chunk, i) => {
      if (chunk.startsWith("<strong>") && chunk.endsWith("</strong>")) {
        return (
          <span key={i} style={{ color: "#ff4500", fontWeight: "bold" }}>
            {chunk.replace(/<\/?strong>/g, "")}
          </span>
        );
      }
      return chunk;
    });
  };

  const getIconSize = () => {
  const screenWidth = window.innerWidth;
  if (screenWidth < 768) return { width: 20, height: 28 }; // Mobile
  if (screenWidth < 1200) return { width: 25, height: 34 }; // Tablet
  return { width: 30, height: 41 }; // Desktop
};



  const [tourInfo, setTourInfo] = useState({ Firstsite: "", Lastsite: "",  Duration: "", days: [] });
  const [tour, setTour] = useState({ name: "", details: [] });
  const [coords, setCoords] = useState([]);
  const [popupInfo, setPopupInfo] = useState(null);
  
  
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [startingAddress, setStartingAddress] = useState("");
  const [routePath, setRoutePath] = useState([]);
  const [directionsResult, setDirectionsResult] = useState(null);
  const [directionsRequest, setDirectionsRequest] = useState(null);
  const mapRef = useRef(null);
  const [showRoute, setShowRoute] = useState(false);
  const [destination, setDestination] = useState(null);
  const [userLocation, setUserLocation] = useState(null);
  const { translateText, lang } = Translator();
  const [ttsAudioUrl, setTtsAudioUrl] = useState(null);
  const [isSpeaking, setIsSpeaking] = useState(false);
//  const globalAudioRef = useRef(null);
  const navigate = useNavigate();
  const [mediaType, setMediaType] = useState("photo"); // or "video" if we want to show video by default
  const [subtitleUrl, setSubtitleUrl] = useState(null);
  const tourVideoRef = useRef(null);
  const [tourMuted, setTourMuted] = useState(true);
  const [showTourMuteBtn, setShowTourMuteBtn] = useState(true);
  const adContainerRef = useRef(null);
  const ima = useRef({ adsLoader: null, adsManager: null, adDisplayContainer: null });
  const hasRequestedAd = useRef(false);
  const [showAdStart, setShowAdStart] = useState(true);
  const [adPlaying, setAdPlaying] = useState(false);



  const baseText = {
    text1: "Tour:",
    textFallback: "Mappa del tour",
    text2: "Lasciati guidare da TecheTour Digital Immersion per rivivere sul territorio con piccolo prezzo le sue bellezze in autonomia, senza prenotare la guida turistica!",
    text3: "giorno",
    text4: "giorni",
    text5: "Ti consigliamo di dedicare almeno due giornate per vivere a pieno l’autenticità di tradizioni millenarie.",
    text6: "per vivere a pieno l’autenticità di tradizioni millenarie.",
    text7: "Esplorazione ",
    text7_1: "La mia posizione",
    text7_2: "Seleziona la posizione di partenza",
    text7_3: "Seleziona la posizione di destinazione",
    text8: "Nessun titolo",
    text9: "Preparando il tuo tour...",
    text10: "Errore: ",
    text11: "Non sono disponibili dettagli sul tour.",
    text12: "Me",
    text13: "Nascondi percorso",
    text14: "Mostra il percorso consigliato",
    text15: "Caricamento mappa...",
    text16: "Scopri di più",
    text166: "Il tuo browser non supporta il tag video",
    text17: "➔",
    text18:"I punti di partenza e di arrivo sono gli stessi. Saltare le direzioni.",
    text19: "Riprova",
    text20: "(ritento...)",
    text24: "🔇 Attiva Audio",
    text25_2: "🔊 Disattiva Audio",
  
    


    
    text25: "Impossibile ottenere la posizione attuale.",
    text26: "Ottieni indicazioni stradali",
    text27: "Nessuna sottotitolo disponibile",
    text28: "Nessuna descrizione disponibile",
    text29: "Nessun audio disponibile",
    text30: "Giorno consigliato ",
    text31: "Foto",
    text32: "Video",
    
    
  };

// Translate base text from Italian to the selected language
  const [translatedText, setTranslatedText] = useState(baseText);
  useEffect(() => {
    const translateAll = async () => {
      const entries = Object.entries(baseText);
      const translatedEntries = await Promise.all(
        entries.map(async ([key, value]) => [key, await translateText(value)])
      );
      setTranslatedText(Object.fromEntries(translatedEntries));
    };

    translateAll();
  }, [lang]);



  const ADS = {HERO_TOP: "1388418800", AFTER_DESC: "1388418800", BETWEEN_DAYS: "1388418800", MULTIPLEX_FOOT: "1388418800", };


  


  



  // -----------------------------
  //  Fetch Polly TTS
  // -----------------------------
  const speakWithPolly = async (text) => {
    try {
      setIsSpeaking(true);
      setTtsAudioUrl(null); // reset before request

      const body = new URLSearchParams({ text, lang });

      const res = await fetch("https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/speak", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body.toString()
      });
      const audioUrl = await res.text();
  
      setTtsAudioUrl(audioUrl);
    } catch (err) {
      //console.error("TTS failed:", err);
      setTtsAudioUrl(null);
    } finally {
      setIsSpeaking(false);
    }
  };


  useEffect(() => {
    setTtsAudioUrl(null);  // Reset audio on each language change
  }, [lang]);


  useEffect(() => {
    const tryLoadTourAudio = async () => {
      if (!tour.descrizione) return;

      const audioUrl = tour.TourAudio || null;

      if (audioUrl) {
        try {
          const response = await fetch(audioUrl, { method: 'HEAD' });
          if (response.ok) {
            setTtsAudioUrl(audioUrl); // Use uploaded audio
            return;
          }
        } catch (error) {
          //console.warn("Audio file not found, falling back to TTS", error);
        }
      }

      if (audioUrl) {
        // Check if audio exists by trying to fetch HEAD
        try {
          const response = await fetch(audioUrl, { method: 'HEAD' });
          if (response.ok) {
            setTtsAudioUrl(audioUrl); // Use uploaded audio
            return;
          }
        } catch (error) {
          //console.warn("Audio file not found, falling back to TTS", error);
        }
      }

      // If audio not found or not provided, use Polly TTS
      speakWithPolly(tour.descrizione);
    };

    tryLoadTourAudio();
  }, [tour.descrizione, tour.TourAudio, tour.TourAudio_it, lang]);

  








/*

// --------------------------------------------------------------
//  Audio Players - Prevent multiple audios from playing at once
// --------------------------------------------------------------
const handlePlay = (audioElement) => {
  if (globalAudioRef.current && globalAudioRef.current !== audioElement) {
    globalAudioRef.current.pause();
  }
  globalAudioRef.current = audioElement;
};*/








useEffect(() => {
  if (!startingAddress || !destination) return;
  
    // Prevent directions if origin and destination are the same
    if (
      startingAddress.lat === destination.lat &&
      startingAddress.lng === destination.lng
    ) {
      alert(translatedText.text18);
      return;
    }
  
  const panelEl = document.getElementById("directionsPanel");
  if (panelEl) panelEl.innerHTML = "";

  const request = {
    origin: startingAddress,
    destination: destination,
    travelMode: "DRIVING"
  };

  setDirectionsResult(null);      //  force rerender if route already existed
  setDirectionsRequest(request);
  //setShowRoute(true);
}, [startingAddress, destination]);






useEffect(() => {
  if (!navigator.geolocation) {
    //console.warn("Geolocation not supported");
    return;
  }
  navigator.geolocation.getCurrentPosition(
    ({ coords }) => {
      setUserLocation({
        lat: coords.latitude,
        lng: coords.longitude
      });
    },
    (err) => {
      //console.warn("Could not get user location", err);
    }
  );
}, []);







useEffect(() => {
  let aborted = false;                 // prevent state updates if unmounted
  const controller = new AbortController();

  const fetchTourData = async () => {
    setError(null);
    setLoading(true);

    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
      try {
        // --- The original clearing state block ---
        setTourInfo({ Firstsite: "", Lastsite: "", Duration: "", days: [] });
        setTour({ name: "", details: [], descrizione: "", subheading: "", image: null });
        setCoords([]);
        setPopupInfo(null);
        setRoutePath([]);
        setDirectionsResult(null);
        setDirectionsRequest(null);
        
        
        // count views (best-effort)
        axios.get(`${BASE}/addTourViews?tourID=${tourID}`).catch(() => {});

        // ---- your original 3 requests ----
        const [tourResponse, giornoDescResponse, giornoTappeResponse] = await Promise.all([
          axios.get(`${BASE}/getTecheTourByIDNew?nodeID=${tourID}&lang=${lang}`, { signal: controller.signal }),
          axios.get(`${BASE}/getTecheTappaDescNew?tourID=${tourID}&lang=${lang}`, { signal: controller.signal }),
          axios.get(`${BASE}/getGiornoTappe?tourID=${tourID}`, { signal: controller.signal }),
        ]);

        if (aborted) return;

        const tourData = tourResponse.data.tour;
        const giornoDescData = giornoDescResponse.data;
        const tourDetails = Array.isArray(giornoTappeResponse.data) ? giornoTappeResponse.data : [];

        setTourInfo({
          Firstsite: tourData.Firstsite,
          Lastsite: tourData.Lastsite,
          Duration: tourData.duration || "N/A",
          days: Array.isArray(giornoDescData) ? giornoDescData : [],
        });

        setTour({
          ...tourData,
          name: tourData.Name_it || "Teche Tour",
          subheading: tourData.Subheading_it || "Teche Tour",
          descrizione: tourData.Description_it || "No tour description",
          details: tourDetails,
          image: tourData.Image ? `${BASE}/media/${tourData.Image}` : null,
          TourAudio: (() => {
            const audioField = lang === "en" ? tourData.TourAudio_en : tourData.TourAudio_it;
            return audioField ? `${BASE}/media/${audioField}` : null;
          })(),
          TourVideo: tourData.TourVideo ? `../ToursVideos/${tourData.introVideo}` : null,
          TourSubtitle: tourData.subtitle_it || null,
        });

        await fetchCoordinates(tourDetails, tourData);
        // success -> exit loop
        setRetrying(false);
        setLoading(false);
        return;

      } catch (err) {
        if (aborted) return;
        // last attempt -> surface error
        if (attempt === MAX_ATTEMPTS) {
          setRetrying(false);
          setLoading(false);
          setError(err?.message || "Unknown error");
          return;
        }
        // schedule another try
        setRetrying(true);
        const backoff = BASE_BACKOFF_MS * Math.pow(2, attempt - 1);
        await sleep(backoff);
      }
    }
  };

  fetchTourData();

  return () => {
    aborted = true;
    controller.abort();
  };
}, [tourID, lang]);









  // -----------------------------
  //  Fetch Coordinates
  // -----------------------------
const fetchCoordinates = async (tourDetails, tourData) => {
  try {
    const gpsCoordsList = Object.entries(tourData)
      .filter(([key]) => key.startsWith("tappaGPS"))
      .sort(([a], [b]) => {
        const numA = parseInt(a.replace("tappaGPS", ""));
        const numB = parseInt(b.replace("tappaGPS", ""));
        return numA - numB;
      });

    const enrichedCoords = await Promise.all(
      gpsCoordsList.map(async ([key, value], index) => {
        const [lat, lon] = value.split(",").map(Number);
        const day = index + 1;

        const tappeID = tourDetails?.[index]?.tappe?.[0]; // First tappa for that day
        if (!tappeID) return null;

        try {
          const { data: detailData } = await axios.get(`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/getTappaTextNew?TappaID=${tappeID}&lang=${lang}`);
          const details = Array.isArray(detailData) ? detailData[0] : {};

          return {
            id: tappeID,
            lat,
            lon,
            day,
            name: tourData[`it_tappaname${day}`] || `Tappa ${day}`,
            description: tourData[`it_Subheadingtappa${day}`] || "",
            text: details?.Text || "",
            image: details?.Immagine ? `https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${details.Immagine}` : null,
          };
        } catch (err) {
          console.error(`Error fetching site info for ID ${tappeID}`, err);
          
        }
      })
    );

    const validCoords = enrichedCoords.filter(Boolean);
    setCoords(validCoords);

    const pathArray = validCoords.map(({ lat, lon }) => ({ lat, lng: lon }));
    setRoutePath(pathArray);

  } catch (error) {
    console.error("Error fetching coordinates:", error);
  }
};

  
  
  
  // To be checked
  // -----------------------------
  //  Google Maps Helpers
  // -----------------------------
  const getDirection = (site) => {
    const destination = `${site.lat},${site.lon}`;
    const origin = startingAddress ? encodeURIComponent(startingAddress) : "";
    const googleMapsUrl = origin
      ? `https://www.google.com/maps/dir/?api=1&origin=${origin}&destination=${destination}`
      : `https://www.google.com/maps/dir/?api=1&destination=${destination}`;
    window.open(googleMapsUrl, "_blank");
  };


  // -----------------------------
  //  Show Driving Route on Map
  // -----------------------------
useEffect(() => {
  // if toggle is OFF or we don't have enough points, clear directions and exit
  if (!showRoute || !coords || coords.length < 2) {
    setDirectionsRequest(null);
    setDirectionsResult(null);
    return;
  }

  const origin = { lat: coords[0].lat, lng: coords[0].lon };
  const destination = { lat: coords[coords.length - 1].lat, lng: coords[coords.length - 1].lon };

  const waypoints = coords.slice(1, -1).map((c) => ({
    location: { lat: c.lat, lng: c.lon },
    stopover: true,
  }));

  setDirectionsResult(null);
  setDirectionsRequest({
    origin,
    destination,
    waypoints,
    optimizeWaypoints: false, // keep 1 → 2 → 3 …
    travelMode: "DRIVING",
  });
}, [showRoute, coords]);





// -----------------------------
//  Tour Video Mute Toggle
// -----------------------------
const toggleTourMute = () => {
  const v = tourVideoRef.current;
  if (!v) return;
  v.muted = !tourMuted;
  setTourMuted(!tourMuted);
  // setShowTourMuteBtn(false); // optional: remove this line if you want the button to stay visible
};

// Keep React state in sync even if user uses native controls
useEffect(() => {
  const v = tourVideoRef.current;
  if (!v) return;
  const onVol = () => setTourMuted(v.muted);
  v.addEventListener("volumechange", onVol);
  return () => v.removeEventListener("volumechange", onVol);
}, []);






  // -----------------------------
  //  Fetch Subtitles URL for Video
  // -----------------------------
  useEffect(() => {
    setSubtitleUrl(null);
    if (!tourID || !lang) return;
    const load = async () => {
    try {
      if (tour.subtitles?.[lang]) {
        setSubtitleUrl(tour.subtitles[lang]);
        return;
      }
      const { data } = await axios.get(`${BASE}/subtitles?tourID=${tourID}&lang=${lang}`);
      setSubtitleUrl(data.url || null);
      } catch {
        setSubtitleUrl(null);
      }
    };
    load();
  }, [tourID, lang]);







const ENABLE_VIDEO_ADS = process.env.REACT_APP_ENABLE_VIDEO_ADS === "true";
// ------------- IMA: init + request preroll -------------
const AD_TAG_URL =
  process.env.REACT_APP_VAST_TAG ||
  // Google test VAST (safe for dev; won’t pay):
  "https://pubads.g.doubleclick.net/gampad/ads?iu=/21775744923/external/single_preroll&sz=640x480&cust_params=deployment%3Ddevsite%26sample_ct%3Dlinear&gdfp_req=1&env=vp&output=vast&unviewed_position_start=1&correlator=" + Date.now();
  // ------------- IMA: load SDK once -------------
function loadIMAScript() {
  return new Promise((resolve) => {
    if (window.google?.ima) return resolve();
    const s = document.createElement("script");
    s.src = "https://imasdk.googleapis.com/js/sdkloader/ima3.js";
    s.async = true;
    s.onload = resolve;
    document.head.appendChild(s);
  });
}

// ^ use this test tag first. Replace later with your real VAST ad tag.

async function requestPreroll() {
  if (!ENABLE_VIDEO_ADS) return;          // ⬅️ guard
  await loadIMAScript();
  const videoEl = tourVideoRef.current;
  const slotEl = adContainerRef.current;
  if (!videoEl || !slotEl) return;

  // Create/initialize display container (must be from a user gesture)
  const { ima: IMA } = window.google;
  ima.current.adDisplayContainer = new IMA.AdDisplayContainer(slotEl, videoEl);
  ima.current.adDisplayContainer.initialize();

  // Create loader once
  ima.current.adsLoader = new IMA.AdsLoader(ima.current.adDisplayContainer);

  // Single onAdError handler
  const onAdError = (evt) => {
    setAdPlaying(false);
    const err = evt?.getError?.()?.getMessage?.() || evt;
    console.log("[IMA] Ad ERROR:", err);
    tourVideoRef.current?.play?.().catch(() => {});
  };

  // Single ADS_MANAGER_LOADED handler
  ima.current.adsLoader.addEventListener(
    IMA.AdsManagerLoadedEvent.Type.ADS_MANAGER_LOADED,
    (e) => {
      try {
        const adsManager = e.getAdsManager(videoEl);
        ima.current.adsManager = adsManager;

        // Mid-roll scheduling example
        adsManager.addEventListener(IMA.AdEvent.Type.CONTENT_RESUME_REQUESTED, () => {
          const current = tourVideoRef.current?.currentTime || 0;
          if (current < 55) {
            setTimeout(() => {
              try { adsManager.start(); } catch {}
            }, Math.max(0, 60000 - current * 1000));
          }
        });

        adsManager.addEventListener(IMA.AdErrorEvent.Type.AD_ERROR, onAdError);
        

        adsManager.addEventListener(IMA.AdEvent.Type.STARTED, () => {
  console.log("[IMA] Ad STARTED");
  setAdPlaying(true);
});
adsManager.addEventListener(IMA.AdEvent.Type.ALL_ADS_COMPLETED, () => {
  setAdPlaying(false);
  slotEl.innerHTML = "";
  videoEl.play().catch(() => {});
});
adsManager.addEventListener(IMA.AdEvent.Type.COMPLETE, () => {
  setAdPlaying(false);
});
adsManager.addEventListener(IMA.AdErrorEvent.Type.AD_ERROR, onAdError);
        

        // Start ad
        videoEl.pause();
        const rect = slotEl.getBoundingClientRect();
        adsManager.init(rect.width || 640, rect.height || 360, IMA.ViewMode.NORMAL);
        adsManager.start();
      } catch (err) {
        console.log("[IMA] getAdsManager() failed:", err);
        videoEl.play().catch(() => {});
      }
    },
    false
  );


  ima.current.adsLoader.addEventListener(IMA.AdErrorEvent.Type.AD_ERROR, onAdError, false);

  // Build & request ad tag (test VAST)
  const req = new IMA.AdsRequest();
  req.adTagUrl = AD_TAG_URL;
  const rect = slotEl.getBoundingClientRect();
  req.linearAdSlotWidth = rect.width || 640;
  req.linearAdSlotHeight = rect.height || 360;
  req.nonLinearAdSlotWidth = rect.width || 640;
  req.nonLinearAdSlotHeight = 150;

  console.log("[IMA] requesting…", AD_TAG_URL);
  ima.current.adsLoader.requestAds(req);
}















// ------------- Run pre-roll on user's first Play -------------
useEffect(() => {
  if (!ENABLE_VIDEO_ADS) return;          // ⬅️ off in prod for now
  if (mediaType !== "video" || !tour.TourVideo) return;
  const v = tourVideoRef.current;
  if (!v) return;

  const onFirstPlay = () => {
    if (hasRequestedAd.current) return;
    hasRequestedAd.current = true;
    v.pause();
    requestPreroll();
  };

  v.addEventListener("play", onFirstPlay, { once: true });
  return () => v.removeEventListener("play", onFirstPlay);
}, [mediaType, tourID, tour.TourVideo, ENABLE_VIDEO_ADS]);


const handleUserPlay = async () => {
  if (hasRequestedAd.current) return;
  hasRequestedAd.current = true;
  setShowAdStart(false);           // hide the button
  await requestPreroll();          // this calls AdDisplayContainer.initialize() from a user click
};


  

  
  const [retrying, setRetrying] = useState(false);
  const MAX_ATTEMPTS = 2;           // try once, then one retry (total 2)
  const BASE_BACKOFF_MS = 800;      // first wait 0.8s, then 1.6s, etc.
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  if (loading) {
  return (
    <div className="flex justify-center items-center h-screen">
      <p className="text-xl font-semibold text-[#000000]">
        {retrying ? `${translatedText.text9} ${translatedText.text20}` : translatedText.text9}
      </p>
    </div>
  );
}

if (error) {
  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4">
      <p className="text-xl font-semibold text-red-600">
        {translatedText.text10} {error}
      </p>
      <button
        onClick={() => {
          window.location.reload();
        }}
        className="px-4 py-2 rounded-md bg-[#324B8E] text-white"
      >
        {translatedText.text19}
      </button>
    </div>
  );
}









  // -----------------------------
  //  JSX Return
  // -----------------------------
  return (


        <div className="p-6">

  <LoadScriptNext googleMapsApiKey={GOOGLE_MAPS_API_KEY} language={lang} region="IT" loadingElement={<div>{translatedText.text15}</div>} >
  
    <div className="w-full overflow-x-hidden">
      <div className="w-full bg-[#324B8E] flex flex-col items-center">
        {/* Title */}
          <h1 className="mt-10 text-center font-bold text-3xl sm:text-4xl md:text-5xl leading-tight text-white font-['Montserrat'] break-words px-4">
            {tour.name ? ` ${tour.name}` : translatedText.textFallback}
          </h1>
      

        {/* Subheading */}
          <h2 className="mt-4 text-center font-medium text-[20px] sm:text-[22px] md:text-[24px] lg:text-[26px] xl:text-[28px] text-white mb-10">
            {tour.subheading}
          </h2>

        {/* Tour Main Image & Video */}
        {/* Switch Buttons */}
        <div className="flex justify-center gap-4 my-4">
          <button
            onClick={() => setMediaType("photo")}
            style={{
              backgroundColor: mediaType === "photo" ? "#49B15D" : "#ffffff",
              color: mediaType === "photo" ? "white" : "black",
              fontWeight: "bold",
              padding: "0.75rem 2rem",
              minWidth: "150px",
              borderRadius: "12px",
              border: "none",
              cursor: "pointer"
            }}
          >
            {translatedText.text31}
          </button>
          
          {tour.TourVideo && (
            <button
              onClick={() => setMediaType("video")}
              style={{
                backgroundColor: mediaType === "video" ? "#49B15D" : "#ffffff",
                color: mediaType === "video" ? "white" : "black",
                fontWeight: "bold",
                padding: "0.75rem 2rem",
                minWidth: "150px",
                borderRadius: "12px",
                border: "none",
                cursor: "pointer"
              }}
            >
              {translatedText.text32}
            </button>
          )}
        </div>

        {/* Display media based on toggle */}
        <div className="w-full aspect-[1920/700] overflow-hidden max-w-screen">
          {mediaType === "photo" && tour.image && (
            <img
              src={tour.image}
              alt="Tour"
              className="w-full h-full object-cover"
            />
          )}

          {mediaType === "video" && tour.TourVideo && (
            <div className="relative w-full h-full">
              <div
                ref={adContainerRef}
                className="absolute inset-0 z-30"
                style={{ pointerEvents: adPlaying ? "auto" : "none" }}
              />

              <video
                ref={tourVideoRef}
                key={`${tourID}-${subtitleUrl || "no-sub"}`}
                src={tour.TourVideo}
                autoPlay
                muted={tourMuted}
                loop
                controls
                playsInline
                preload="metadata"
                crossOrigin="anonymous"
                className="w-full h-full object-cover"
                onPlay={() => claimMedia(tourVideoRef.current)}
              >
                {subtitleUrl && (
                  <track
                    key={subtitleUrl}
                    label={lang.toUpperCase()}
                    kind="subtitles"
                    srcLang={lang}
                    src={subtitleUrl}
                    default
                  />
                )}
                {translatedText.text16 || translatedText.text166}
              </video>


    {showTourMuteBtn && (
      <button
        type="button"
        onClick={toggleTourMute}
        aria-label={tourMuted ? translatedText.text24 : translatedText.text25_2}
        className="absolute right-4 bottom-4 z-10 px-3 py-2 rounded-md bg-black/60 text-white font-semibold backdrop-blur-sm hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-white/70"
      >
        {tourMuted ? translatedText.text24 : translatedText.text25_2}
      </button>
    )}




  </div>

  
)}




        </div>






        {/* Description nw */}
        <div className="w-full max-w-[100%] px-6 mt-6 mb-24 text-white">
            <p
              className="text-sm sm:text-base md:text-base lg:text-base leading-[1.8] text-justify text-white"
              style={{
                textAlign: "justify",
                textJustify: "inter-word",
                hyphens: "auto",
              }}
            >
              {tour.descrizione.replace(/<\/?[^>]+(>|$)/g, "")}
            </p>




<br />



        {/* Tour Main Audio  */}
        {ttsAudioUrl && (
  <>
    {/*console.log("Rendering AudioPlayer with URL:", ttsAudioUrl)*/}
    <AudioPlayer
      src={ttsAudioUrl}
      autoPlay={false}
      showSkipControls={false}
      showJumpControls={false}
      customAdditionalControls={[]}
      customVolumeControls={["volume"]}
      layout="horizontal-reverse"
      onPlay={(e) => claimMedia(e.target)}
    />
  </>
)}


        </div>
      </div>



<br />
<br />
<br />
<br />







<div
  style={{
    backgroundColor: "#f2f2f2",
    width: "90%",
    textAlign: "center",
    margin: "0 auto 0.625rem auto"                                      // marginBottom: "0.625rem" 
  }}
>

    


    {/* Directions panel 
    <div style={{ display: "flex", height: "100%", gap: "1rem" }}>
      {showRoute && (
      <div
        style={{
          width: "24%",
          height: "100%", // Match parent height
         // padding: "1rem",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto", // Make scrollable
          boxSizing: "border-box"
        }}
      >

<select
  onChange={(e) => {
    const value = e.target.value;
    setDirectionsResult(null);

    if (value === "current-location") {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          setStartingAddress(userLocation);
        },
        () => {
          alert(translatedText.text25);
        }
      );
    } else {
      const [lat, lng] = value.split(",").map(Number);
      setStartingAddress({ lat, lng });
    }
  }}
  
  defaultValue=""
  style={{
    width: "100%",
    padding: "0.5rem",
    borderRadius: "6px",
    marginBottom: "0.5rem"
  }}
>
  <option value="" disabled>{translatedText.text7_2}</option>
  <option value="current-location">📍 {translatedText.text7_1}</option>
  {coords.map((coord, idx) => (
    <option key={idx} value={`${coord.lat},${coord.lon}`}>
      {translatedText.text7} {coord.day}: {coord.name}
    </option>
  ))}
</select>


<select
      onChange={(e) => {
        const value = e.target.value;
        setDirectionsResult(null);
        if (value === "current-location") {
          navigator.geolocation.getCurrentPosition(
            (position) => {
              const userLocation = {
                lat: position.coords.latitude,
                lng: position.coords.longitude,
              };
              setDestination(userLocation); 
            },
            () => {
              alert(translatedText.text25);
            }
          );
        } else {
            const [lat, lng] = e.target.value.split(",").map(Number);
            setDestination({ lat, lng });
          }
        }}   
        defaultValue=""
        style={{
          width: "100%",
          padding: "0.5rem",
          borderRadius: "6px",
          marginBottom: "0.5rem"
        }}
    >
      <option value="" disabled>{translatedText.text7_3}</option>
      <option value="current-location">📍 {translatedText.text7_1}</option>
      {coords.map((coord, idx) => (
        <option key={idx} value={`${coord.lat},${coord.lon}`}>
          {translatedText.text7} {coord.day}: {coord.name}
        </option>
      ))}
    </select>



    <div
      id="directionsPanel"
      style={{
        flex: "1",
        maxHeight: "400px",
        overflowY: "auto",
        border: "1px solid #ccc",
        borderRadius: "10px",
        backgroundColor: "#fff",
        padding: "1rem"

      }}
        />
  </div>
)}





















*/}





  <div style={{ position: "relative"
               //, width: showRoute ? "75%" : "100%" 
              }}>

    {/* Route Toggle Button */}
    <button
      //onClick={() => setShowRoute(!showRoute)}
      onClick={() => setShowRoute((s) => !s)}  
      style={{
        width: "60%",
        //maxWidth: "200px",
        position: "absolute",
        top: "10px",
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1000,
        padding: "10px 16px",
        backgroundColor: "#324B8E",
        color: "white",
        border: "none",
        borderRadius: "6px",
        fontSize: "14px",
        cursor: "pointer",
        boxShadow: "0 2px 6px rgba(0,0,0,0.3)"
      }}
    >
      {showRoute ? translatedText.text13 : translatedText.text14}
    </button>


















      <GoogleMap
        //center={initialMapCenter}
        onLoad={(map) => {
          mapRef.current = map;
          if (coords.length) {
            const bounds = new window.google.maps.LatLngBounds();
            coords.forEach(({ lat, lon }) => bounds.extend({ lat, lng: lon }));
            map.fitBounds(bounds);

            window.google.maps.event.addListenerOnce(map, "bounds_changed", () => {
              map.setZoom(map.getZoom() - 1);
            });
          }
        }}
        zoom={8}               // zoom lower number is 3
        mapContainerStyle={{
          width: "100%",
          height: "500px",              //100% in esplorazione page
          border: "2px solid #ccc",
          borderRadius: "10px",
        }}
        
        options={{
          minZoom: 4, // to Prevent zooming out too far
          maxZoom: 20,
          mapTypeControl: true,
          fullscreenControl: true,
        }}

      >
        {/* 1) Render Markers */}
        {coords.map((site) => (
          <Marker
          key={`${site.id}-${site.day}`}
          position={{ lat: site.lat, lng: site.lon }}
          icon={{
            url: "/marker.svg",
//          scaledSize: { width: 30, height: 41 }
            scaledSize: getIconSize()

          }}
          onClick={() => {
            setPopupInfo(site);
//            setHoverInfo(null);
          }}
          label={{
            text: site.name,
            color: "blue",
            fontSize: "0.8vw",
            fontWeight: "bold",
          }}
      
     /*     icon={{
            url: "data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=", // 1x1 transparent gif
          }}
*/
        />
        
        ))}
        




        







        {userLocation && (
  <Marker
    position={userLocation}
    title="Me"
    label={{ text: translatedText.text12, color: "yellow", fontWeight: "bold" }}
    icon={{
      url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
    }}
  />
)}












                  {/* 3) Popup InfoWindow (on marker click) + Polyline */}
                  {popupInfo && (
            
              <InfoWindow
                position={{ lat: popupInfo.lat, lng: popupInfo.lon }}
                onCloseClick={() => setPopupInfo(null)}
              >
                 <div style={{
                    maxWidth: "20vw",
                    maxHeight: "25vh",
                    overflowY: "auto",
                    padding: "1%",
                    fontSize: "clamp(0.8rem, 1vw, 1.1rem)",
                    lineHeight: "1.4",
                    borderRadius: "0.5rem",
                  }}>

<h4 style={{ margin: "0.5% 0", fontSize: "clamp(1rem, 1vw, 1.25rem)", fontWeight: "bold", textAlign: "center" }}> {translatedText.text30} {popupInfo.day}</h4>

<h4 style={{ margin: "0.5% 0", fontSize: "clamp(1rem, 1vw, 1.25rem)", fontWeight: "bold", textAlign: "center" }}>
  <a 
    href={`/esplorazione/${tourID}&${popupInfo.day}`} 
    target="_blank" 
    rel="noopener noreferrer"
  >
    {popupInfo.name}
  </a>
</h4>










    <p style={{ margin: "10px 0" }}>
      {popupInfo.description.length > 100
        ? popupInfo.description.substring(0, 100) + "..."
        : popupInfo.description}
    </p>
    <button onClick={() => getDirection(popupInfo)} style={{
      backgroundColor: "#324B8E",
      color: "white",
      padding: "5px 10px",
      borderRadius: "5px",
      border: "none",
      cursor: "pointer",
      display: "block",
      margin: "5px auto"
    }}>
                    🧭 {translatedText.text26}
                  </button>
                </div>
              </InfoWindow>









              
            
          )}





























                      {/* Directions logic 
                      {showRoute && directionsRequest && (
        <DirectionsService
        key={JSON.stringify(directionsRequest)} // 🆕 Force remount on change
        options={directionsRequest}
        callback={(res, status) => {
          console.log("Directions callback:", { status, res });
          if (status === "OK") {
            setDirectionsResult(res);
          } else {
            console.error("Directions request failed:", status);
          }
        }}
      />
      
      )}



      {showRoute && directionsResult && (
        <DirectionsRenderer
          options={{
            directions: directionsResult,
            suppressMarkers: true,
            panel: document.getElementById("directionsPanel"),
            polylineOptions: {
              strokeColor: "#FF0000",
              strokeOpacity: 0.8,
              strokeWeight: 5,
            },
            preserveViewport: true
          }}
        />
      )}
*/}

{showRoute && directionsRequest && (
  <DirectionsService
    key={JSON.stringify(directionsRequest)}
    options={directionsRequest}
    callback={(res, status) => {
      if (status === "OK") setDirectionsResult(res);
      else console.error("Directions failed:", status);
    }}
  />
)}

{showRoute && directionsResult && (
  <DirectionsRenderer
    options={{
      directions: directionsResult,
      suppressMarkers: true,
      polylineOptions: { 
        strokeColor: "#324b8e",
        strokeOpacity: 1,
        strokeWeight: 6 
      },
      preserveViewport: true,
    }}
  />
)}





















        
      </GoogleMap>






      </div>





    






<br />
<br />

{/* Tour tappe part after the map */}

    <div>
      {/* Render Tour tappe */}
  
      {
      //tourInfo.days.length > 0 && (
      Array.isArray(tourInfo.days) && tourInfo.days.length > 0 && (
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          
          {tourInfo.days.map((day, index) => (
            <div key={index} className="w-full overflow-x-auto mb-6">
              
              {/* Exploration header */}
              <h4 style={{ textAlign: "left", fontSize: "32px", fontWeight: "bold", color: "#000000", marginBottom: "0.5rem" }}>
                {`${translatedText.text7} ${index + 1}`}
              </h4>



              {/* Header Box */}
              <div
                style={{
                  width: "100%",
                  padding: "1rem",
                  fontSize: "1.125rem",
                  fontWeight: "bold",
                  backgroundColor: "#324b8e",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  marginBottom: "10px",
                  textAlign: "left",
                  paddingLeft: "0.5rem", 
                  position: "relative"
                }}
              >

                      <span>{day.tappaname || translatedText.text8}</span>
                      {tour[`it_Subheadingtappa${index + 1}`] && (
                        <span className="block lg:inline font-normal opacity-90 lg:ml-2">
                          — {tour[`it_Subheadingtappa${index + 1}`]}
                        </span>
                      )}

              </div>






                <div className="flex flex-col lg:flex-row gap-4 items-stretch bg-white  pb-4">
              
           
{/* Left: Tappa image   */}
<div className="w-full lg:w-1/2 max-h-full aspect-video rounded-xl overflow-hidden">
                    {(() => {
                      let images = [];
                      try {
                        images = day.img ? JSON.parse(day.img) : [];
                      } catch (err) {
                        //console.error("Invalid image JSON in day.img", err);
                      }

                      return (
                        Array.isArray(images) && images.length > 0 && (
                          <img
                            src={`https://xmrhe4snn1.execute-api.eu-north-1.amazonaws.com/media/${images[0]}`}
                            alt={`Giorno ${index + 1}`}
                            
                          />
                        )
                      );
                    })()}
                  </div>


























                    
                  





















              {/* Center: Description */}
              <div className="w-full ">
<div className="w-full lg:w-[95%] flex flex-col justify-between h-full">


      {/* Tappa Description */}
      <div className="text-black text-justify leading-relaxed text-[1.0625rem] whitespace-pre-line space-y-4 mb-4">
      {parseBoldText(decodeHtmlEntities(day.desc).replace(/<br\s*\/?>/g, " "))}
      </div>



<div className="flex justify-end mt-auto">
  <span
    onClick={() => navigate(`/esplorazione/${tourID}&${index + 1}`)} // Replace with my action
    className="text-[#324B8E] font-bold text-[20px] cursor-pointer inline-flex items-center"
  >
    {translatedText.text16} &nbsp;{translatedText.text17}
  </span>
</div>
</div>

 












    </div>



    {/* Right: Scopri di piu */}













        

  </div>

























                
            </div>



          ))}
        </div>
      )}

  
    </div>








{/*
<br />
<br />
<h4 style={{ textAlign: "center", fontSize: "40px", fontWeight: "bold", color: "#000000" }}>{translatedText.text2} </h4>
<h4 style={{ textAlign: "center", fontSize: "24px", fontWeight: "bold", color: "#000000" }}>{translatedText.text5} </h4>
*/}

<br />
<br />







     



     </div>

     
     </div>

  </LoadScriptNext>




      {/* ✅ Show Ad only here */}
      <AdBanner />


<div style={{ position:'relative', zIndex:1, padding:16, background:'#f2f2f2' }}>
  <AdSlot slot="1388418800" />
</div>



      {/* Maybe another ad after video or description */}
      {/* <AdBanner /> */}
    </div>

  );

};

export default Tour;
